'use strict';

import * as Props from '../Props';

const angular = require('angular');

const SignatureProperties = {
    Basic: {
        'ControlType': 'Signature',
        'Label': {
            name: 'label',
            selectedValue: 'Signature',
            type: 'textbox',
            onClickFunction: 'openLanguageDialog',
            addOnButton: 'fa fa-globe'
        },
        'Field Name': Props.getFieldName('Signature'),
        'Data Field Name': Props.getDataFieldName('Signature'), 
        'Value': {
            selectedValue: '',
            type: 'textbox',
            hidden: true
        },
        'Required': {
            name: 'required',
            selectedValue: false,
            type: 'checkbox'
        },
        'Name': {
            selectedValue: 'Basic',
            hidden: true
        },
        'Type': {
            name: 'type',
            type: 'dd',
            options: [
                {
                    value: 'standard',
                    key: 'Standard'
                }, {
                    value: 'fullScreen',
                    key: 'Full Screen'
                }],
            selectedValue: 'standard',
            onChangeFunction: 'signatureTypeChanged'
        },
    },
    Display: {
        'Read-only': {
            name: 'read.only',
            selectedValue: false,
            type: 'checkbox'
        },
        'Hidden': {
            name: 'hidden',
            selectedValue: false,
            type: 'checkbox'
        },
        'Name': {
            selectedValue: 'Display',
            hidden: true
        }
    },
    Margin: angular.copy(Props.marginObject),
    Style: {
        'font-style-group': {
            type: 'style-group',
            members: {
                'font-family': {
                    type: 'dd',
                    title: 'font.family',
                    selectedValue: 'Helvetica',
                    options: ['Arial', 'Arial Black', 'Bookman Old Style', 'Calibri', 'Century Gothic', 'Comic Sans MS', 'Courier', 'Courier New', 'Garamond', 'Georgia', 'Helvetica', 'Impact', 'Palatino Linotype', 'Sans Serif', 'Sofia Pro Regular', 'Sofia Pro Semi Bold', 'Times', 'Times New Roman', 'Trebuchet MS', 'Verdana'],
                    onChangeFunction: 'updateStyle'
                },
                'font-size': {
                    type: 'number',
                    title: 'font.size',
                    selectedValue: 14,
                    min: '1',
                    max: '99',
                    default: 14,
                    onChangeFunction: 'updateStyle'
                },
                'background-color': {
                    type: 'color-picker',
                    title: 'background.color',
                    selectedValue: '#ffffff',
                    icon: 'fa fa-paint-brush',
                    onChangeFunction: 'updateStyle'
                }
            }
        },
        'style-group': {
            type: 'style-group',
            members: {
                'bold': {
                    type: 'btn-toggle',
                    title: 'bold',
                    icon: 'fa fa-bold',
                    selectedValue: false,
                    onChangeFunction: 'updateStyle'
                }, 'italic': {
                    type: 'btn-toggle',
                    title: 'italic',
                    icon: 'fa fa-italic',
                    selectedValue: false,
                    onChangeFunction: 'updateStyle'
                }, 'underline': {
                    type: 'btn-toggle',
                    title: 'underline',
                    icon: 'fa fa-underline',
                    selectedValue: false,
                    onChangeFunction: 'updateStyle'
                },
                'alignment': {
                    type: 'radio-btn',
                    selectedValue: 'left',
                    options: [{
                        value: 'left',
                        title: 'align.left',
                        icon: 'fa fa-align-left',
                        onChangeFunction: 'updateStyle'
                    }, {
                        value: 'center',
                        title: 'align.center',
                        icon: 'fa fa-align-justify',
                        onChangeFunction: 'updateStyle'
                    }, {
                        value: 'right',
                        title: 'align.right',
                        icon: 'fa fa-align-right',
                        onChangeFunction: 'updateStyle'
                    }]
                },
                'font-color': {
                    type: 'color-picker',
                    title: 'font.color',
                    selectedValue: '#000000',
                    icon: 'fa fa-font',
                    onChangeFunction: 'updateStyle'
                }
            }
        },
        'Name': {
            selectedValue: 'style',
            hidden: true
        }
    },
    Events: {
        Name: angular.copy(Props.elementEventsObject).Name,
        load: angular.copy(Props.elementEventsObject).load,
        change: angular.copy(Props.elementEventsObject).change
    }
};

export default SignatureProperties;


// WEBPACK FOOTER //
// ./client/app/localStorage/Controls/Signature.ts